export default class ScreeningDocumentBatchCreateRequest {
  SubjectIds: string[] = [];
  Status: number = 1;
  Type: number = 1;
  NationalOfficeFileDate: string = "";
  Approved: boolean = false;
  ExpiryDate: string = "";
}
